import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// CHAT APIs (Chatcon Controller)
// ================================

// 🔹 Get or Create Last Conversation
export async function getLastConversation(user_id, website_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_last_conv`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getLastConversation error:", error);
    return { status: false, type: "danger", success: "Failed to fetch conversation" };
  }
}

// 🔹 Get Conversation List
export async function getConversations(user_id, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_convs/${page_no}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getConversations error:", error);
    return { status: false, type: "danger", success: "Failed to fetch conversations" };
  }
}

// 🔹 Create New Conversation
export async function createConversation(user_id, website_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}chat/create_conv_now`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createConversation error:", error);
    return { status: false, type: "danger", success: "Failed to create conversation" };
  }
}

// 🔹 Get Messages by Conversation
export async function getMessages(conv_id, user_id, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("conv_id", conv_id);
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_msgs/${page_no}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getMessages error:", error);
    return { status: false, type: "danger", success: "Failed to load messages" };
  }
}

// 🔹 Send Message
export async function sendMessage(msg_txt,msg_conv,user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("msg_conv", msg_conv);
    fd.append("msg_txt", msg_txt);

    const response = await axios.post(`${apiBaseUrl}chat/send_msg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("sendMessage error:", error);
    return { status: false, type: "danger", success: "Failed to send message" };
  }
}

// 🔹 Get AI Message (Chatbot Reply)
export async function getAIMessage(msg_id, analytics_data = {}) {
  try {
    const fd = new FormData();
    fd.append("msg_id", msg_id);
    fd.append("analytics_data", JSON.stringify(analytics_data));

    const response = await axios.post(`${apiBaseUrl}chat/get_ai_msg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getAIMessage error:", error);
    return { status: false, type: "danger", success: "Failed to fetch AI reply" };
  }
}

// 🔹 Delete Conversation
export async function deleteConversation(conv_id) {
  try {
    const fd = new FormData();
    fd.append("conv_id", conv_id);

    const response = await axios.post(`${apiBaseUrl}chat/delete_chat/${conv_id}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteConversation error:", error);
    return { status: false, type: "danger", success: "Failed to delete chat" };
  }
}
